import React from 'react'
import {
	Drawer,
	Row,
	Space,
	Typography,
	List,
	Tag,
	Divider,
	Button
} from 'antd'
import {
	CloseOutlined, LikeOutlined, DislikeOutlined, StarFilled
} from '@ant-design/icons'
import moment from 'moment'

export interface IFormattedTaskRating {
	id: number
	name: string
	reaction: 'LIKE' | 'DISLIKE'
}

export interface IFormattedRating {
	id: number
	rating: number
	comment: string
	createdAt: string
	address: string | null
	taskRatings: IFormattedTaskRating[]
}

interface RatingsDetailDrawerProps {
	ratings: IFormattedRating[]
	open: boolean
	onClose: () => void
}

const RatingsDetailDrawer: React.FC<RatingsDetailDrawerProps> = ({ ratings, open, onClose }) => (
	<Drawer
		title={
			<Row justify="space-between" align="middle">
				<Space>
					<CloseOutlined style={{ color: '#aaa' }} onClick={onClose} />
					<Typography.Text strong>Detail hodnotení</Typography.Text>
				</Space>
			</Row>
		}
		width={800}
		visible={open}
		onClose={onClose}
		closeIcon={null}
	>
		<List
			itemLayout="vertical"
			dataSource={ratings}
			renderItem={(item) => (
				<List.Item key={item.id}>
					<Row justify="space-between" align="middle">
						<Space>
							{[...Array(item.rating)].map((_, idx) => (
								<StarFilled key={idx} style={{ color: '#fadb14' }} />
							))}
							<Typography.Text type="secondary">
								{moment(item.createdAt).format('DD.MM.YYYY HH:mm')}
							</Typography.Text>
						</Space>
						{item.address && <Tag color="blue">{item.address}</Tag>}
					</Row>

					<Divider style={{ margin: '12px 0' }} />

					<Typography.Paragraph>{item.comment}</Typography.Paragraph>

					<div style={{ marginTop: 8 }}>
						{item.taskRatings.map((task) => (
							<Tag
								key={task.id}
								icon={task.reaction === 'LIKE' ? <LikeOutlined /> : <DislikeOutlined />}
								color={task.reaction === 'LIKE' ? 'green' : 'red'}
								style={{ marginBottom: 4 }}
							>
								{task.name}
							</Tag>
						))}
					</div>
				</List.Item>
			)}
		/>
	</Drawer>
)

export default RatingsDetailDrawer
